import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class MembresiaBeneficios {
    static typeSearch      = "local" //online || local
    Id              = null;
    Tenant          = "";
    FechaCreacion   = "";
    Plan            = "";
    Beneficios      = [];

    constructor(data) {
        this.Id             = (data.Id)?data.Id:null;
        this.Tenant         = (data.Tenant)?data.Tenant:store.getters.getFirebaseApp.tenant;
        this.FechaCreacion  = data.FechaCreacion;
        this.Plan           = data.Plan;
        this.Beneficios     = (data.Beneficios)?data.Beneficios:[];
        this.typeSearch      = "local"
    }

    static async getByPlan(id){
        if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Beneficios")
            .where("Plan","==",id)
            .where("Tenant", "==",store.getters.getFirebaseApp.tenant).get();
            if(data.empty){
                return false;
            }else{
                let doc = data.docs.map(doc=>{return {Id:doc.ref.id,...doc.data()}});
                return new MembresiaBeneficios(doc[0]);
            }
        }else if(this.typeSearch == "local"){
            let pgsHelper  = new PGSHelper();
            let datos =pgsHelper.getById(store.getters["dataLists/getMbsBeneficios"],'Plan',id);
            if(datos){
                datos.Id = datos.id;
            }else{
                return false
            }
            return new MembresiaBeneficios(datos);
        }
    }

    static async getById(id){
        if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Beneficios").doc(id).get();
            if(!data.exists){
                return false;
            }else{
                let doc = {Id:data.ref.id,...data.data()};
                return new MembresiaBeneficios(doc);
            }
        }else if(this.typeSearch == "local"){
            let pgsHelper  = new PGSHelper();
            let datos = pgsHelper.getById(store.getters["dataLists/getMbsBeneficios"],'Pid',id);
            datos.Id = datos.id;
            return new MembresiaBeneficios(datos);
        }
    }

    editBeneficio(beneficio){
        this.Beneficios[beneficio.index] = JSON.parse(JSON.stringify(beneficio));
        this.Beneficios = JSON.parse(JSON.stringify(this.Beneficios));
    }


    addBeneficio(beneficio){
        this.Beneficios.push(beneficio);
    }

    removeBeneficio(index){
        this.Beneficios.splice(index, 1);
    }

    activarBeneficio(index){
        this.Beneficios[index].Activo = true;
    }

    desactivarBeneficio(index){
        this.Beneficios[index].Activo = false;
    }


    getBeneficiosList(){
        return this.Beneficios;
    }

    /*
     * Obtiene el beneficio de RVA dentro del listado de beneficios
     * @param string departamento - Filtro para obtener beneficio por departamento
     * @return Array - Array de beneficios RVA
    */
    getRVABeneficio(departamento = null){
        let beneficios      = this.Beneficios;
        let list_beneficios = [];
        beneficios.forEach((beneficio)=>{
            if(beneficio.Tipo == "RVA"){
                if(departamento){
                    if(beneficio.Departamento == departamento){
                        list_beneficios.push(beneficio);
                    }
                }else{
                    list_beneficios.push(beneficio);
                }
            }
        });
        return list_beneficios;
    }
    /*
     * Obtiene el beneficio de CON dentro del listado de beneficios
     * @param string producto - Filtro para obtener beneficio por producto
     * @return Array - Array de beneficios CON
    */
    getCONBeneficio(producto = null){
        let beneficios = this.Beneficios;
        let list_beneficios = [];
        beneficios.forEach((beneficio)=>{
            if(beneficio.Tipo === "CON"){
                //if(beneficio.ItemId == producto){
                    list_beneficios.push(beneficio);
                //}
            }
        })

        return list_beneficios;
    }
    /*
     * Obtiene el beneficio de PRO dentro del listado de beneficios
     * @param string promocion - Filtro para obtener beneficio por promocion
     * @return Array - Array de beneficios PRO
    */
    getPROBeneficio(promocion = null){
        let beneficios = this.Beneficios;
        let list_beneficios = [];
        beneficios.forEach((beneficio)=>{
            if(beneficio.Tipo == "PRO"){
                /*if(beneficio.PromoId == promocion){
                    list_beneficios.push(beneficio);
                }*/
            //}else{
                list_beneficios.push(beneficio);
            }
        })

        return list_beneficios;
    }



}